<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="container">
                        <component v-bind:is="loader" v-if="component"></component>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="container">
                        <slot name="footer">
                            <button class="btn btn-primary m-2" :disabled="isSubmittable" id="btnSubmit" @click="submitModal()">{{ $t('Continue') }}</button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";

export default {
    name: "pipl-k11",
    props: {
        submitModal: {
            type: Function,
            default: () => 1,
        },
    },
    data() {
        return {component: null}
    },
    components: {},
    created() {
    },
    computed: {
        ...mapGetters(['getPipl', 'isSubmittable', 'getAppLanguage']),
        loader() {
            let version = this.getPipl('PIPL_CONSENT_VERSION') ?? 'general';
            console.log("this.getAppLanguage", this.getAppLanguage)
            switch (this.getAppLanguage) {
                case "zh_HK":
                    return () => import(`@/components/pipl-k11-${version}-pipl-tc.vue`);
                case "zh_CN":
                    return () => import(`@/components/pipl-k11-${version}-pipl-sc.vue`);
                case "en":
                default:
                    return () => import(`@/components/pipl-k11-${version}-pipl-en.vue`);
            }
        },
    },
    methods: {
        ...mapMutations(['setPIPL', 'setAppLanguage']),
    },
    mounted() {
        this.loader().then((compo) => {
            this.component = compo
        })
    },
};
</script>


<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: block;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: flex;
    flex-direction: column;
    vertical-align: middle;
    max-height: 100vh;
    background-color: #fff;
}

.modal-container {
    //margin: 0px auto; padding-top: 20px;
    padding-top: 30px;
    //padding-right: 30px;
    //padding-left: 30px;
    //padding-bottom: 20px;
    border-radius: 2px;
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
    overflow-y: auto;
}

.modal-header h3 {
    margin-top: 0;
    color: #42b983;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

</style>
